import React from 'react'

export const Commitment = (props) => {
  return (
   <>
   <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 80.68 74.79"
    {...props}
  >
    <defs>
     
    </defs>
    <rect
      width={4.03}
      height={9.05}
      x={38.29}
      y={7.63}
      className="cls-2"
      rx={2.02}
      ry={2.02}
    />
    <rect
      width={4.03}
      height={9.05}
      x={26.59}
      y={9.73}
      className="cls-2"
      rx={2.02}
      ry={2.02}
      transform="rotate(-30 28.603 14.244)"
    />
    <rect
      width={4.03}
      height={9.05}
      x={49.99}
      y={9.73}
      className="cls-2"
      rx={2.02}
      ry={2.02}
      transform="rotate(-150 52.002 14.254)"
    />
    <path
      d="m58.06 22.88 11.99 20.71 8.29-4.96-11.72-20.61-8.56 4.86zM22.62 23.05 10.63 43.76 2.34 38.8l11.72-20.61 8.56 4.86z"
      className="cls-2"
    />
    <path
      d="M48.36 26.25a12.743 12.743 0 0 0 10.79-1.5M44.11 23.72c-.39-.35-1.12-.91-2.18-1.2-1.82-.5-3.34.15-3.79.37-3.81 2.36-7.61 4.73-11.42 7.09 1.06 2.96 2.38 3.88 3.38 4.18 2.52.77 4.13-2.06 7.53-1.57 2.56.37 3.1 2.18 5.18 2.05 2.02-.12 3.53-1.95 4.45-3.35"
      className="cls-2"
    />
    <path
      d="M52.81 45.38c3.26 1.85 6.53 3.7 9.8 5.54.17.1.34.19.51.29 2.21-.34 3.86-1.93 4.07-3.77.18-1.62-.81-2.85-1.05-3.13-6.63-3.89-13.26-7.78-19.89-11.66"
      className="cls-2"
    />
    <path
      d="m62.61 50.92.3.69c.34 2.22-.6 4.3-2.28 5.19-1.34.7-2.71.41-3.16.29-.22-.13-.43-.26-.65-.39-2.71-1.64-5.42-3.28-8.12-4.93M56.82 56.7h0c.04.1.08.19.12.29.34 2.22-.6 4.3-2.28 5.18-1.34.7-2.71.41-3.16.29l-1.98-1.2c-2.27-1.37-4.53-2.74-6.8-4.11"
      className="cls-2"
    />
    <path
      d="M49.53 61.26c.03.09.07.17.11.26.34 2.23-.61 4.31-2.28 5.19-1.34.7-2.71.41-3.17.29-1.97-1.19-3.94-2.39-5.92-3.58M19.038 50.26l4.4-2.826a3.572 3.572 0 0 1 4.934 1.074h0a3.572 3.572 0 0 1-1.074 4.933l-4.4 2.827a2.164 2.164 0 0 1-2.985-.65l-1.524-2.372a2.164 2.164 0 0 1 .65-2.985ZM20.39 40.5c-.21.07-.42.18-.62.31l-5.44 3.48-.27.18c-1 .65-1.29 1.98-.65 2.99l1.53 2.37c.64 1 1.98 1.3 2.98.65l5.71-3.66a3.566 3.566 0 0 0 1.64-3.01c0-.62-.16-1.26-.51-1.83M24.98 55.273l4.4-2.827a3.572 3.572 0 0 1 4.932 1.074h0a3.572 3.572 0 0 1-1.073 4.934l-4.4 2.827a2.164 2.164 0 0 1-2.985-.65l-1.525-2.373a2.164 2.164 0 0 1 .65-2.985Z"
      className="cls-2"
    />
    <path
      d="m31.207 59.732 2.289-1.47a3.572 3.572 0 0 1 4.933 1.074h0a3.572 3.572 0 0 1-1.074 4.933l-2.288 1.47a2.164 2.164 0 0 1-2.985-.65l-1.525-2.372a2.164 2.164 0 0 1 .65-2.985ZM11.65 42l1.42 1.13 1.26 1.16M68.99 41.75l-2.71 2.73"
      className="cls-2"
    />
  </svg>
   </>
  )
}
